import { connect } from 'react-redux';

import get from 'lodash/get';
import PropTypes from 'prop-types';

import AccessCardsListComponent from './AccessCardsListComponent';

import { confirmDeleteAccessCard, getAccessCardsList } from './actions';

const LIST_KEY = 'accessCards';

const AccessCardsListContainer = (props) => {
  const { onGetAccessCardsList, listParams } = props;
  const onExport = (paginationParams) => {
    const queryParams = { ...listParams, ...paginationParams };
    return onGetAccessCardsList(queryParams);
  };
  return <AccessCardsListComponent {...props} onExport={onExport} />;
};

AccessCardsListContainer.propTypes = {
  onGetAccessCardsList: PropTypes.func.isRequired,
  listParams: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = (state) => {
  const {
    accessCards: { list: items, batch },
  } = state;
  const batchOptions = [];
  if (Array.isArray(batch)) {
    batch.forEach((item) =>
      batchOptions.push({
        ...item,
        name: item?.name,
      }),
    );
  }
  return {
    items,
    listKey: LIST_KEY,
    listParams: get(state, `lists.${LIST_KEY}`, {}),
    batchOptions,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onLoad: (params) =>
    getAccessCardsList(dispatch, { ...params, disable_pagination: true }, true),
  getItems: (queryParams) => getAccessCardsList(dispatch, queryParams),
  onRemove: (id, queryParams) =>
    confirmDeleteAccessCard(dispatch, id, queryParams),
  onGetAccessCardsList: (queryParams) =>
    getAccessCardsList(dispatch, queryParams, false, true),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AccessCardsListContainer);
